import $ from "jquery";

export const init = () => {
  const $navbarToggler = $(".navbar-toggler");
  const $mainMenu = $("#mainmenu");

  $navbarToggler.click(function (e) {
    e.preventDefault();
    $("body").toggleClass("menu-open");
    $mainMenu.slideToggle();

    e.stopPropagation();
  });

  let body = document.querySelector("body");
  document.addEventListener("click", (e) => {
    if (
      body.classList.contains("menu-open") &&
      e.target.closest(".navbar") == null &&
      e.target
    ) {
      $navbarToggler.click();
    }
  });

  $mainMenu.find(".has-submenu > a > .ai").click(function (e) {
    e.preventDefault();
    const $menuItem = $(this).closest("li");
    const $subMenu = $menuItem.find("> .submenu").first();
    $subMenu.slideToggle();
    $menuItem.toggleClass("m-open");
    const $submenuWrapper = $menuItem.find("> .submenu-wrapper").first();
    $submenuWrapper.slideToggle();
  });
};
